import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from "react";
import { Dialog, DialogDescription, DialogTitle } from "../../base/dialog/dialog";
import { CelebrationCheck } from "../../base/celebration-check/celebration-check";
import { DialogShell } from "../dialog-shell/DialogShell";
import { DialogShellFooter } from "../dialog-shell/DialogShellFooter";
export function SuccessDialog({ open, title, description, primary, secondary, onDismiss }) {
    const primaryRef = useRef(null);
    return /*#__PURE__*/ _jsx(Dialog, {
        open: open,
        onOpenChange: (next)=>!next && onDismiss(),
        children: /*#__PURE__*/ _jsxs(DialogShell, {
            size: "sm",
            onOpenAutoFocus: (event)=>{
                // The footer renders the secondary first, so Radix's default would
                // focus it. Focusing here (not via `autoFocus`) lets FocusScope track
                // the primary and pull focus back to it. A disabled primary cannot
                // take focus, so Radix's own fallback stays in charge then.
                if (!primaryRef.current || primaryRef.current.disabled) return;
                event.preventDefault();
                primaryRef.current.focus();
            },
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex flex-col items-center gap-3 px-8 pb-6 pt-10 text-center",
                    children: [
                        /*#__PURE__*/ _jsx(CelebrationCheck, {
                            size: "lg"
                        }),
                        /*#__PURE__*/ _jsx(DialogTitle, {
                            className: "mt-3 font-display text-2xl font-semibold",
                            children: title
                        }),
                        /*#__PURE__*/ _jsx(DialogDescription, {
                            className: "max-w-sm text-sm text-muted-foreground",
                            children: description
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(DialogShellFooter, {
                    primary: primary,
                    primaryRef: primaryRef,
                    secondary: secondary
                })
            ]
        })
    });
}

//# sourceMappingURL=success-dialog.js.map